import { createFileRoute } from '@tanstack/react-router'
import { requireActiveSubscription, requireRoles } from '@/lib/middleware'
import { REGISTER_WRITE_ROLES } from '@/features/medication-register/access'
import { CloseRegisterPage } from '@/features/medication-register/close-register-page'

/** Closing a register is a manager write (X2). */
export const Route = createFileRoute(
  '/_authenticated/_organization/compliance/drugs-register/$accountId/close'
)({
  beforeLoad: async () => {
    await requireRoles([...REGISTER_WRITE_ROLES])
    await requireActiveSubscription()
  },
  component: CloseRegisterPage,
})
